<template>
  <div class="flex flex-col md:flex-row justify-between w-full flex-wrap gap-6">
    <Breadcrumbs :items="breadcrumbsItems" full-width-on-mobile />
    <slot />
  </div>
</template>
<script setup lang="ts">
import { Breadcrumbs } from '~/components/breadcrumbs';
import { RouteLocationRaw } from 'vue-router';

type Props = {
  breadcrumbsItems: { label: string; to: RouteLocationRaw }[];
};

defineProps<Props>();
</script>
